<template>
  <div>
    <p id="navbanner" class="navbanner">
      <span class="navbanner__title">{{
        `${$store.state.content.settings.navigation.bannerTitle[$lang.current]}, `
      }}</span>
      <a
        :href="$store.state.content.settings.links.repertoire"
        class="navbanner__link"
        rel="noopener"
        target="_blank"
        >{{ $store.state.content.settings.navigation.bannerRedirect[$lang.current] }}</a
      >
    </p>
    <nav id="navbar" :class="['navbar', { '-collapsed': isCollapsed }]">
      <div class="navbar__content row -mobile -align-center -spread">
        <PageLink :to="{ name: 'home' }" class="navbar__logo">
          <img :src="$wp.logo.navBar" alt="Forum IA Québec" />
        </PageLink>

        <menu v-if="$device.laptop" class="navbar__menu row -align-center">
          <NavLink v-for="link in navLinks" :key="link.label" v-bind="link" class="navbar__pages row" />

          <PageLink :to="contactLink" class="button navbar__contact">
            <Icon id="chat" />
            {{ $wp.navigation.contactLabel[$lang.current] }}
          </PageLink>

          <RouterLink v-for="lang in langLinks" :key="lang" :to="$lang.switch(lang)" class="navbar__link -lang">{{
            lang.toUpperCase()
          }}</RouterLink>

          <Transition name="navbar__overlay" :duration="325">
            <PageLink v-if="isContactOpen" :to="contactLink" class="navbar__overlay-close">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 243.7 39.4" class="navbar__overlay-curve">
                <path
                  fill-rule="evenodd"
                  d="M243.7 0a103.997 103.997 0 00-60.92 19.7c-36.372 26.26-85.478 26.26-121.85 0A104.074 104.074 0 000 0h243.7z"
                />
              </svg>
            </PageLink>
          </Transition>
        </menu>

        <menu v-else class="row -mobile -align-center">
          <PageLink :to="contactLink" class="navbar__contact-mobile">
            <Icon id="chat" />
          </PageLink>

          <PageLink :to="$store.getters.overlayLink('mobile-nav')" class="navbar__burger">
            <i :class="['navbar__burger-icon', { '-close': isMobileNavOpen }]" />
          </PageLink>

          <Transition name="navbar__overlay" :duration="325">
            <PageLink v-if="isContactOpen" :to="contactLink" class="navbar__overlay-close">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 243.7 39.4" class="navbar__overlay-curve">
                <path
                  fill-rule="evenodd"
                  d="M243.7 0a103.997 103.997 0 00-60.92 19.7c-36.372 26.26-85.478 26.26-121.85 0A104.074 104.074 0 000 0h243.7z"
                />
              </svg>
            </PageLink>
          </Transition>
        </menu>
      </div>
    </nav>
  </div>
</template>

<script>
import { NavLink } from '@/components/partials'

export default {
  name: 'NavBar',
  contentKey: 'settings',
  components: { NavLink },
  props: {
    isCollapsed: { type: Boolean, default: false }
  },
  computed: {
    contactLink() {
      return this.$store.getters.overlayLink('contact')
    },
    isContactOpen() {
      return this.$route.query.overlay === 'contact'
    },
    isMobileNavOpen() {
      return this.$route.query.overlay === 'mobile-nav'
    },
    navLinks() {
      const { links = [] } = this.$wp.navigation
      const { current = 'fr' } = this.$lang
      return links.map(({ label, anchors, to }) => ({ anchors, to: this.$lang.route(to), label: label[current] }))
    },
    langLinks() {
      const { list, current } = this.$lang
      return list.filter(lang => lang !== current)
    }
  }
}
</script>
